export default "__VITE_ASSET__BvjszI7Z__"